import { FC, useEffect } from 'react';
import { ExaminationPagePatientModel } from '../models';
import { useIntl } from 'react-intl';
import { AuscultationPointListItem } from '@higo/common/src/components/Auscultation/AuscultationPointListItem';
import {
  useHeartAuscultationPhysicalExaminationQuery,
  useHeartAuscultationPhysicalExaminationResourceFiles,
} from '@higo/common/src/features/ExaminationPage/hooks/queries';

export interface LiveVisitHeartAusculationSectionProps {
  examinationId: number;
  patientModel: ExaminationPagePatientModel;
  point: any;
}

export const LiveVisitHeartAusculationSection: FC<LiveVisitHeartAusculationSectionProps> =
  ({ point }) => {
    const { data, refetch } = useHeartAuscultationPhysicalExaminationQuery(
      point.examId,
    );
    const specificPointData = data?.heartAuscultationResults.filter(
      (item) => item.pointer?.toString() === point.auscultationPointIndex,
    );
    const intl = useIntl();

    const specificPointFileId =
      specificPointData && specificPointData[0] && specificPointData[0].fileId;

    const { data: fileResourceMap } =
      useHeartAuscultationPhysicalExaminationResourceFiles(point.examId);

    let specificPointFileResourceMap;

    for (let key in fileResourceMap) {
      if (
        specificPointFileId &&
        fileResourceMap[key].fileId &&
        fileResourceMap[key].fileId === specificPointFileId
      ) {
        specificPointFileResourceMap = fileResourceMap[key];
        break;
      }
    }

    const label = `${intl.formatMessage({
      id: 'common.point',
    })} -${point.auscultationPointIndex}`;

    useEffect(() => {
      refetch();
    }, [point]);

    return (
      <>
        <>
          {fileResourceMap && specificPointFileId && (
            <AuscultationPointListItem
              id={point.auscultationPointIndex}
              key={point.auscultationPointIndex}
              label={label}
              file={specificPointFileResourceMap}
            />
          )}
        </>
      </>
    );
  };
